import React from 'react'
import { BackendKeywordTag } from '../../constants/tags'
import KeywordTag from './KeywordTag'
import { Column, ColumnHeader, ColumnItems } from './styled'

interface KeywordColumnProps {
  letter: string
  items: BackendKeywordTag[]
  language: string
  minCount: number
  maxCount: number
  onSelectKeyword: (keywordId: number) => void
}

const KeywordColumn = ({
  letter,
  items,
  language,
  minCount,
  maxCount,
  onSelectKeyword,
}: KeywordColumnProps) => (
  <Column>
    <ColumnHeader>
      <div className="column-letter">{letter}</div>
      <div className="invisible">{letter}</div>
    </ColumnHeader>
    <ColumnItems $itemCount={items.length}>
      {items.map(keyword => (
        <KeywordTag
          key={keyword.id}
          keyword={keyword}
          language={language}
          minCount={minCount}
          maxCount={maxCount}
          onSelect={onSelectKeyword}
        />
      ))}
    </ColumnItems>
  </Column>
)

export default React.memo(KeywordColumn)
